const MAX_DRIVER_COUNT = 9999;
const MIN_DRIVER_COUNT = 0;

const WEEKDAYS = [
  { field: 'mondayDriverCount', label: 'Monday' },
  { field: 'tuesdayDriverCount', label: 'Tuesday' },
  { field: 'wednesdayDriverCount', label: 'Wednesday' },
  { field: 'thursdayDriverCount', label: 'Thursday' },
  { field: 'fridayDriverCount', label: 'Friday' }
];

const WEEKEND = [
  { field: 'saturdayDriverCount', label: 'Saturday' },
  { field: 'sundayDriverCount', label: 'Sunday' }
];

const ALL_DAYS = [...WEEKDAYS, ...WEEKEND];

const getDefaultDriverPreferenceInfo = (driverPreferenceInfo) => {
  const info = {
    defaultDriverCount: driverPreferenceInfo?.defaultDriverCount ?? null,
    startTime: driverPreferenceInfo?.startTime ?? null
  };
  ALL_DAYS.forEach(({ field }) => {
    info[field] = driverPreferenceInfo?.[field] ?? null;
  });
  return info;
};

const getFieldError = (field, value, toggleState) => {
  const REQUIRED_FIELD_ERROR = '* Required';
  if (field === 'startTime') {
    return value?.trim() ? null : REQUIRED_FIELD_ERROR;
  }

  if (field === 'defaultDriverCount') {
    if (toggleState.dayOfWeek) {
      return null;
    } else {
      if (value === 0) {
        return '* Driver count must be greater than zero';
      }
      return value ? null : REQUIRED_FIELD_ERROR;
    }
  }

  return value || value === 0 ? null : REQUIRED_FIELD_ERROR;
};

const getErrorInfo = (driverPreferenceInfo, toggleState) => {
  const fieldsToValidate = ['startTime', 'defaultDriverCount'];

  if (toggleState.dayOfWeek) {
    fieldsToValidate.push(...WEEKDAYS.map(({ field }) => field));
  }

  if (toggleState.weekend) {
    fieldsToValidate.push(...WEEKEND.map(({ field }) => field));
  }

  // Build the error object in a single pass
  return fieldsToValidate.reduce((errors, field) => {
    errors[field] = getFieldError(field, driverPreferenceInfo[field], toggleState);
    return errors;
  }, {});
};

const isToggleOpen = (days, driverPreferenceInfo) => {
  return days.some(
    (day) => driverPreferenceInfo[day.field] || driverPreferenceInfo[day.field] === 0
  );
};

const getDayOfWeekCounts = (driverPreferenceInfo) => {
  return ALL_DAYS.reduce((acc, day) => {
    acc[day.field] = driverPreferenceInfo[day.field] ?? null;
    return acc;
  }, {});
};

export {
  MAX_DRIVER_COUNT,
  MIN_DRIVER_COUNT,
  ALL_DAYS,
  WEEKDAYS,
  WEEKEND,
  getDefaultDriverPreferenceInfo,
  getFieldError,
  isToggleOpen,
  getErrorInfo,
  getDayOfWeekCounts
};
